export const FETCH_HOST_REPORT_DATA = 'FETCH_HOST_REPORT_DATA';
export const FETCH_HOST_REPORT_SUCCESS = 'FETCH_HOST_REPORT_SUCCESS';
export const FETCH_HOST_REPORT_FAILURE = 'FETCH_HOST_REPORT_FAILURE';

export const FETCH_BLOCKED_REPORT_DATA = 'FETCH_BLOCKED_REPORT_DATA';
export const FETCH_BLOCKED_REPORT_SUCCESS = 'FETCH_BLOCKED_REPORT_SUCCESS';
export const FETCH_BLOCKED_REPORT_FAILURE = 'FETCH_BLOCKED_REPORT_FAILURE';

export const FETCH_GOOGLE_REPORT_DATA = 'FETCH_GOOGLE_REPORT_DATA';
export const FETCH_GOOGLE_REPORT_SUCCESS = 'FETCH_GOOGLE_REPORT_SUCCESS';
export const FETCH_GOOGLE_REPORT_FAILURE = 'FETCH_GOOGLE_REPORT_FAILURE';

export const SET_BLOCKED_REPORT_PAGINATION = 'SET_BLOCKED_REPORT_PAGINATION';
export const SET_BLOCKED_REPORT_FILTERS = 'SET_BLOCKED_REPORT_FILTERS';

export const SET_GOOGLE_REPORT_PAGINATION = 'SET_GOOGLE_REPORT_PAGINATION';
export const SET_GOOGLE_REPORT_FILTERS = 'SET_GOOGLE_REPORT_FILTERS';

export const FETCH_LIVE_COUNTS = 'FETCH_LIVE_COUNTS';
export const FETCH_LIVE_COUNTS_SUCCESS = 'FETCH_LIVE_COUNTS_SUCCESS';
export const FETCH_LIVE_COUNTS_FAILURE = 'FETCH_LIVE_COUNTS_FAILURE';

export const SET_HOST_REPORT_PAGINATION = 'SET_HOST_REPORT_PAGINATION';
export const SET_HOST_REPORT_FILTERS = 'SET_HOST_REPORT_FILTERS';
export const RESET_HOST_REPORT_STATE = 'RESET_HOST_REPORT_STATE';

export const SET_HOST_REPORT_TAB = 'SET_HOST_REPORT_TAB';

export const FETCH_HOST_SPACES = 'FETCH_HOST_SPACES';
export const FETCH_HOST_SPACES_SUCCESS = 'FETCH_HOST_SPACES_SUCCESS';
export const FETCH_HOST_SPACES_FAILURE = 'FETCH_HOST_SPACES_FAILURE';

export const FETCH_HOST_REPORT_STATS = 'FETCH_HOST_REPORT_STATS';
export const FETCH_HOST_REPORT_STATS_SUCCESS = 'FETCH_HOST_REPORT_STATS_SUCCESS';
export const FETCH_HOST_REPORT_STATS_FAILURE = 'FETCH_HOST_REPORT_STATS_FAILURE';

export const EXPORT_REPORT_REQUEST = 'EXPORT_REPORT_REQUEST';
export const EXPORT_REPORT_SUCCESS = 'EXPORT_REPORT_SUCCESS';
export const EXPORT_REPORT_FAILURE = 'EXPORT_REPORT_FAILURE';
